import { isIOS } from 'utils/UserAgent';

const NAVBAR_SCROLL_OFFSET = 64;

export function getLocationFragment(fragment: string) {
  return fragment ? fragment.slice(1) : '';
}

export function scrollToAnchor(element: HTMLElement | null) {
  if (!element) return;

  const elementPosition = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
  const offsetPosition = elementPosition - NAVBAR_SCROLL_OFFSET * 2;

  // using scrollTo instead of scrollIntoView because we need an offset
  // using scrollBy can interrupt the smooth scrolling from scrollIntoView
  // Executes at the next event cycle ensuring that the call stack is cleared before attempting to scroll
  setTimeout(
    () => {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      });
    },
    isIOS ? 500 : 0,
  );
}

export function scrollToPosition(scrollPosition: number) {
  // Executes at the next event cycle ensuring that the callstack is cleared before attempting to scroll
  setTimeout(() => {
    // Forces the browser to give high prioroty by syncing with browser timings to perform the animation before the screen loads
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollPosition);
    });
  });
}

export function scrollToTop() {
  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
  });
}
